import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useI18n } from "@/i18n/I18nContext";

export function WhatsAppButton() {
  const { settings } = useSettings();
  const { t } = useI18n();
  const number = (settings.whatsapp || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  const msg = encodeURIComponent(settings.whatsapp_message || t("whatsapp.default"));
  const href = `https://wa.me/${number}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-cta"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-50 w-12 h-12 flex items-center justify-center bg-forest text-warm border border-warm/20 shadow-lg hover:bg-bronze transition-colors duration-200"
    >
      <MessageCircle size={22} aria-hidden="true" />
    </a>
  );
}
